import { create } from 'zustand'

interface FileObject {
    id: number;
    frontKey?: string;
    fileName: string;
    fileSize: number;
    file: File;
    type: string;
    type_detail: string;
    label: string;
};

interface PersonFiles {
    legalRepresentative: FileObject[];
    beneficiaries: {
        frontFile: FileObject | null;
        backFile: FileObject | null;
        address: FileObject | null;
    }[];
}

interface Files {
    person: PersonFiles;
}

interface FilesStore {
    files: Files;
    addLegalRepresentativeFile: (file: FileObject) => void;
    addBeneficiaryFile: (index: number, frontFile: FileObject | undefined, backFile: FileObject | undefined, address: FileObject | undefined) => void;
    removeLegalRepresentativeFile: (id: number) => void;
    clearLegalRepresentativeFiles: () => void;
    clearAllFiles: () => void;
}

const useFilesStore = create<FilesStore>((set) => ({
    files: {
        person: {
            legalRepresentative: [],
            beneficiaries: []
        }
    },
    addLegalRepresentativeFile: (file) =>
        set((state) => {
            const updatedFiles = state.files.person.legalRepresentative.filter((f) => f.id !== file.id);
            return { 
                files: {
                    ...state.files,
                    person: {
                        ...state.files.person,
                        legalRepresentative: [...updatedFiles, file]
                    }
                }
            };
        }),
    addBeneficiaryFile: (index: number, frontFile?: FileObject | undefined , backFile?: FileObject | undefined, address?: FileObject | undefined) =>
        set((state: any) => {
            const existingBeneficiaries = state.files.person.beneficiaries;
            const existingBeneficiary = existingBeneficiaries[index] || { index, frontFile: undefined, backFile: undefined, address: undefined };
            const updatedBeneficiary = {
                index,
                frontFile: frontFile !== undefined ? frontFile : existingBeneficiary.frontFile,
                backFile: backFile !== undefined ? backFile : existingBeneficiary.backFile,
                address: address !== undefined ? address : existingBeneficiary.address,
            };
            const updatedBeneficiaries = [...existingBeneficiaries];
            updatedBeneficiaries[index] = updatedBeneficiary;

            return {
                files: {
                    ...state.files,
                    person: {
                        ...state.files.person,
                        beneficiaries: updatedBeneficiaries,
                    },
                },
            };
        }),
    removeLegalRepresentativeFile: (id: number) =>
        set((state) => ({
            files: {
                ...state.files,
                person: {
                    ...state.files.person,
                    legalRepresentative: state.files.person.legalRepresentative.filter((f: any) => f.id !== id)
                }
            }
        })),
    clearLegalRepresentativeFiles: () => 
        set((state) => ({ 
            files: {
                ...state.files,
                person: {
                    ...state.files.person,
                    legalRepresentative: []
                }
            }
        })),
    clearAllFiles: () => 
        set({ 
            files: {
                person: {
                    legalRepresentative: [],
                    beneficiaries: []
                }
            }
        }),
}));

export default useFilesStore;
